export const IS_TOUCH = window.matchMedia("(pointer: coarse)").matches;